import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import Avatar from '@/assets/images/avatar.png';
import { initData } from '@/api/data';
import CustomerDrawer from '@/components/CustomerDrawerCom';
import GoodNewsPopup from '@/components/goodNewsPopup/goodNewsPopup';
import UoocWebSocket from '@/utils/webSocket';
import { getCards } from '@/api/admissionCounseling/customerDrawerCom';
import onlineStatusCom from './onlineStatusCom.vue';
import WujieVue from 'wujie-vue2';
export default {
  name: 'NavBar',
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    CustomerDrawer: CustomerDrawer,
    GoodNewsPopup: GoodNewsPopup,
    onlineStatusCom: onlineStatusCom
  },
  dicts: ['good_news_pic'],
  data: function data() {
    return {
      Avatar: Avatar,
      query: {
        page: 0,
        size: 20
      },
      queryPage: 0,
      paperListTotal: 0,
      dialogVisible: false,
      noticeDialog: false,
      notices: 0,
      // 未读消息
      noticeList: [],
      webSocket: null,
      goodNewsId: null,
      goodNews: {},
      goodNewsVisible: false,
      goodNewsTimer: null,
      webSocketId: null,
      // 解决不知道是刷新操作，暂时用定时器延迟的方法
      drawer: {
        isExist: false,
        visible: false,
        cardId: undefined,
        error: '',
        loading: false,
        opts: []
      },
      onlineStatus: undefined
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar', 'device', 'user', 'baseApi'])), {}, {
    show: {
      get: function get() {
        return this.$store.state.settings.showSettings;
      },
      set: function set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        });
      }
    }
  }),
  watch: {
    'webSocket.data.GOOD_NEWS': function webSocketDataGOOD_NEWS(newVal) {
      var goodNewsId = this.goodNewsId,
        openPopup = this.openPopup,
        goodNewsVisible = this.goodNewsVisible,
        closePopup = this.closePopup;
      if (newVal && newVal.id && newVal.id !== goodNewsId) {
        // 0为手动关闭
        this.goodNewsId = newVal.id;
        if (goodNewsVisible) {
          // 短时间内又有喜报需要弹出
          closePopup();
        }
        this.goodNews = newVal;
        openPopup();
      }
    },
    'webSocket.data.ONLINE_STATUS': function webSocketDataONLINE_STATUS(newVal) {
      this.onlineStatus = newVal === 'onLine' ? 0 : 1;
    }
  },
  created: function created() {
    this.getUnreadMsg();
  },
  mounted: function mounted() {
    var initWebSocket = this.initWebSocket,
      listenVue3 = this.listenVue3;
    this.webSocketId = setTimeout(function () {
      initWebSocket();
    }, 20000);
    listenVue3();
  },
  destroyed: function destroyed() {
    var webSocket = this.webSocket,
      goodNewsTimer = this.goodNewsTimer,
      webSocketId = this.webSocketId,
      removeListenVue3 = this.removeListenVue3;
    goodNewsTimer && clearTimeout(goodNewsTimer) && clearTimeout(webSocketId);
    // 因为延时了20s才初始化，所以在20s内退出登录会报错，应该先判断
    webSocket && webSocket.closeWeb();
    removeListenVue3();
  },
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    open: function open() {
      var _this = this;
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.logout();
      });
    },
    logout: function logout() {
      var $store = this.$store,
        $router = this.$router,
        webSocket = this.webSocket;
      // 因为延时了20s才初始化，所以在20s内退出登录会报错，应该先判断
      webSocket && webSocket.logout();
      $store.dispatch('LogOut').then(function () {
        $router.replace('/login');
      });
    },
    // 获取未读消息
    getUnreadMsg: function getUnreadMsg() {
      var _this2 = this;
      // 5分钟=300000ms重复执行一次
      window.setInterval(function () {
        initData('api/notices/unread-count').then(function (res) {
          _this2.notices = res.count;
        });
      }, 300000);
    },
    // 打开未读消息对话框
    openUnreadMsg: function openUnreadMsg() {
      this.noticeDialog = true;
      this.getNoticesList();
    },
    //  查询通知列表
    getNoticesList: function getNoticesList() {
      var _this3 = this;
      initData('api/notices', this.query).then(function (res) {
        _this3.noticeList = res.content;
        _this3.paperListTotal = res.totalElements;
      });
    },
    closeUnreadMsg: function closeUnreadMsg() {
      this.noticeDialog = false;
      this.notices = 0;
    },
    handleDrawer: function handleDrawer() {
      var drawer = this.drawer,
        clearSelect = this.clearSelect;
      !drawer.isExist && (drawer.isExist = true);
      drawer.visible = !drawer.visible;
      if (!drawer.visible) {
        clearSelect();
      }
    },
    // 分页-点击页数跳转到对应的页的数据
    paperListPageChange: function paperListPageChange(num) {
      this.query.page = num === 0 ? 0 : num - 1;
      this.getNoticesList();
      this.queryPage = num;
    },
    // 分页-每页显示的条目数
    paperListSizeChange: function paperListSizeChange(num) {
      this.query.size = num;
      this.getNoticesList();
    },
    initWebSocket: function initWebSocket() {
      this.webSocket = new UoocWebSocket('GOOD_NEWS');
      this.webSocket.initWebSocket();
    },
    closePopup: function closePopup() {
      this.goodNewsVisible = false;
      this.goodNews = {};
    },
    openPopup: function openPopup() {
      this.goodNewsVisible = true;
      var goodNews = this.goodNews,
        closePopup = this.closePopup;
      var closeTime = goodNews.closeTime;
      if (closeTime) {
        // 0为手动关闭
        var timer = goodNews.closeTime * 1000;
        this.goodNewsTimer = setTimeout(function () {
          closePopup();
        }, timer);
      }
    },
    handleSearch: function handleSearch(num) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var handleSearchLoading, drawer, $message, res, tip;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              handleSearchLoading = _this4.handleSearchLoading, drawer = _this4.drawer, $message = _this4.$message;
              if (!num.trim()) {
                _context.n = 2;
                break;
              }
              handleSearchLoading();
              _context.n = 1;
              return getCards(num);
            case 1:
              res = _context.v;
              drawer.opts = res.rows;
              handleSearchLoading();
              _context.n = 3;
              break;
            case 2:
              tip = '不可输入空格';
              drawer.error = tip;
              // 上面的字被遮了一半，看不清
              $message({
                type: 'error',
                message: tip
              });
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleSearchLoading: function handleSearchLoading() {
      var drawer = this.drawer;
      drawer.loading = !drawer.loading;
    },
    handleChange: function handleChange() {
      var handleDrawer = this.handleDrawer;
      handleDrawer();
    },
    clearSelect: function clearSelect() {
      var drawer = this.drawer;
      drawer.cardId = undefined;
    },
    listenVue3: function listenVue3() {
      var drawer = this.drawer,
        handleDrawer = this.handleDrawer;
      // 主应用监听事件
      WujieVue.bus.$on('openClientDrawer', function (args) {
        var cId = args.cId;
        drawer.cardId = cId;
        handleDrawer();
      });
    },
    removeListenVue3: function removeListenVue3() {
      WujieVue.bus.$off('openClientDrawer');
    }
  }
};